import type { PropsWithChildren, ReactNode } from 'react'

import { getIsLoggedIn } from '@/src/features/auth/utils/getIsLoggedIn'

export const AuthenticationRequired = ({ children }: PropsWithChildren): ReactNode => {
  return getIsLoggedIn() ? children : null
}
